import _codemirror from "../../lib/codemirror";
var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/5/LICENSE

// declare global: DOMRect

(function (mod) {
  // CommonJS
  mod(_codemirror);
})(function (CodeMirror) {
  "use strict";

  var HINT_ELEMENT_CLASS = "CodeMirror-hint";
  var ACTIVE_HINT_ELEMENT_CLASS = "CodeMirror-hint-active";

  // This is the old interface, kept around for now to stay
  // backwards-compatible.
  CodeMirror.showHint = function (cm, getHints, options) {
    if (!getHints) return cm.showHint(options);
    if (options && options.async) getHints.async = true;
    var newOpts = {
      hint: getHints
    };
    if (options) for (var prop in options) newOpts[prop] = options[prop];
    return cm.showHint(newOpts);
  };
  CodeMirror.defineExtension("showHint", function (options) {
    options = parseOptions(this || _global, this.getCursor("start"), options);
    var selections = this.listSelections();
    if (selections.length > 1) return;
    // By default, don't allow completion when something is selected.
    // A hint function can have a `supportsSelection` property to
    // indicate that it can handle selections.
    if (this.somethingSelected()) {
      if (!options.hint.supportsSelection) return;
      // Don't try with cross-line selections
      for (var i = 0; i < selections.length; i++) if (selections[i].head.line != selections[i].anchor.line) return;
    }
    if ((this || _global).state.completionActive) (this || _global).state.completionActive.close();
    var completion = (this || _global).state.completionActive = new Completion(this || _global, options);
    if (!completion.options.hint) return;
    CodeMirror.signal(this || _global, "startCompletion", this || _global);
    completion.update(true);
  });
  CodeMirror.defineExtension("closeHint", function () {
    if ((this || _global).state.completionActive) (this || _global).state.completionActive.close();
  });
  function Completion(cm, options) {
    (this || _global).cm = cm;
    (this || _global).options = options;
    (this || _global).widget = null;
    (this || _global).debounce = 0;
    (this || _global).tick = 0;
    (this || _global).startPos = (this || _global).cm.getCursor("start");
    (this || _global).startLen = (this || _global).cm.getLine((this || _global).startPos.line).length - (this || _global).cm.getSelection().length;
    if ((this || _global).options.updateOnCursorActivity) {
      var self = this || _global;
      cm.on("cursorActivity", (this || _global).activityFunc = function () {
        self.cursorActivity();
      });
    }
  }
  var requestAnimationFrame = window.requestAnimationFrame || function (fn) {
    return setTimeout(fn, 1000 / 60);
  };
  var cancelAnimationFrame = window.cancelAnimationFrame || clearTimeout;
  Completion.prototype = {
    close: function () {
      if (!this.active()) return;
      (this || _global).cm.state.completionActive = null;
      (this || _global).tick = null;
      if ((this || _global).options.updateOnCursorActivity) {
        (this || _global).cm.off("cursorActivity", (this || _global).activityFunc);
      }
      if ((this || _global).widget && (this || _global).data) CodeMirror.signal((this || _global).data, "close");
      if ((this || _global).widget) (this || _global).widget.close();
      CodeMirror.signal((this || _global).cm, "endCompletion", (this || _global).cm);
    },
    active: function () {
      return (this || _global).cm.state.completionActive == (this || _global);
    },
    pick: function (data, i) {
      var completion = data.list[i],
        self = this || _global;
      (this || _global).cm.operation(function () {
        if (completion.hint) completion.hint(self.cm, data, completion);else self.cm.replaceRange(getText(completion), completion.from || data.from, completion.to || data.to, "complete");
        CodeMirror.signal(data, "pick", completion);
        self.cm.scrollIntoView();
      });
      if ((this || _global).options.closeOnPick) {
        this.close();
      }
    },
    cursorActivity: function () {
      if ((this || _global).debounce) {
        cancelAnimationFrame((this || _global).debounce);
        (this || _global).debounce = 0;
      }
      var identStart = (this || _global).startPos;
      if ((this || _global).data) {
        identStart = (this || _global).data.from;
      }
      var pos = (this || _global).cm.getCursor(),
        line = (this || _global).cm.getLine(pos.line);
      if (pos.line != (this || _global).startPos.line || line.length - pos.ch != (this || _global).startLen - (this || _global).startPos.ch || pos.ch < identStart.ch || (this || _global).cm.somethingSelected() || !pos.ch || (this || _global).options.closeCharacters.test(line.charAt(pos.ch - 1))) {
        this.close();
      } else {
        var self = this || _global;
        (this || _global).debounce = requestAnimationFrame(function () {
          self.update();
        });
        if ((this || _global).widget) (this || _global).widget.disable();
      }
    },
    update: function (first) {
      if ((this || _global).tick == null) return;
      var self = this || _global,
        myTick = ++(this || _global).tick;
      fetchHints((this || _global).options.hint, (this || _global).cm, (this || _global).options, function (data) {
        if (self.tick == myTick) self.finishUpdate(data, first);
      });
    },
    finishUpdate: function (data, first) {
      if ((this || _global).data) CodeMirror.signal((this || _global).data, "update");
      var picked = (this || _global).widget && (this || _global).widget.picked || first && (this || _global).options.completeSingle;
      if ((this || _global).widget) (this || _global).widget.close();
      (this || _global).data = data;
      if (data && data.list.length) {
        if (picked && data.list.length == 1) {
          this.pick(data, 0);
        } else {
          (this || _global).widget = new Widget(this || _global, data);
          CodeMirror.signal(data, "shown");
        }
      }
    }
  };
  function parseOptions(cm, pos, options) {
    var editor = cm.options.hintOptions;
    var out = {};
    for (var prop in defaultOptions) out[prop] = defaultOptions[prop];
    if (editor) for (var prop in editor) if (editor[prop] !== undefined) out[prop] = editor[prop];
    if (options) for (var prop in options) if (options[prop] !== undefined) out[prop] = options[prop];
    if (out.hint.resolve) out.hint = out.hint.resolve(cm, pos);
    return out;
  }
  function getText(completion) {
    if (typeof completion == "string") return completion;else return completion.text;
  }
  function buildKeyMap(completion, handle) {
    var baseMap = {
      Up: function () {
        handle.moveFocus(-1);
      },
      Down: function () {
        handle.moveFocus(1);
      },
      PageUp: function () {
        handle.moveFocus(-handle.menuSize() + 1, true);
      },
      PageDown: function () {
        handle.moveFocus(handle.menuSize() - 1, true);
      },
      Home: function () {
        handle.setFocus(0);
      },
      End: function () {
        handle.setFocus(handle.length - 1);
      },
      Enter: handle.pick,
      Tab: handle.pick,
      Esc: handle.close
    };
    var mac = /Mac/.test(navigator.platform);
    if (mac) {
      baseMap["Ctrl-P"] = function () {
        handle.moveFocus(-1);
      };
      baseMap["Ctrl-N"] = function () {
        handle.moveFocus(1);
      };
    }
    var custom = completion.options.customKeys;
    var ourMap = custom ? {} : baseMap;
    function addBinding(key, val) {
      var bound;
      if (typeof val != "string") bound = function (cm) {
        return val(cm, handle);
      };
      // This mechanism is deprecated
      else if (baseMap.hasOwnProperty(val)) bound = baseMap[val];else bound = val;
      ourMap[key] = bound;
    }
    if (custom) for (var key in custom) if (custom.hasOwnProperty(key)) addBinding(key, custom[key]);
    var extra = completion.options.extraKeys;
    if (extra) for (var key in extra) if (extra.hasOwnProperty(key)) addBinding(key, extra[key]);
    return ourMap;
  }
  function getHintElement(hintsElement, el) {
    while (el && el != hintsElement) {
      if (el.nodeName.toUpperCase() === "LI" && el.parentNode == hintsElement) return el;
      el = el.parentNode;
    }
  }
  function Widget(completion, data) {
    (this || _global).id = "cm-complete-" + Math.floor(Math.random(1000000));
    (this || _global).completion = completion;
    (this || _global).data = data;
    (this || _global).picked = false;
    var widget = this || _global,
      cm = completion.cm;
    var ownerDocument = cm.getInputField().ownerDocument;
    var parentWindow = ownerDocument.defaultView || ownerDocument.parentWindow;
    var hints = (this || _global).hints = ownerDocument.createElement("ul");
    hints.setAttribute("role", "listbox");
    hints.setAttribute("aria-expanded", "true");
    hints.id = (this || _global).id;
    var theme = completion.cm.options.theme;
    hints.className = "CodeMirror-hints " + theme;
    (this || _global).selectedHint = data.selectedHint || 0;
    var completions = data.list;
    for (var i = 0; i < completions.length; ++i) {
      var elt = hints.appendChild(ownerDocument.createElement("li")),
        cur = completions[i];
      var className = HINT_ELEMENT_CLASS + (i != (this || _global).selectedHint ? "" : " " + ACTIVE_HINT_ELEMENT_CLASS);
      if (cur.className != null) className = cur.className + " " + className;
      elt.className = className;
      if (i == (this || _global).selectedHint) elt.setAttribute("aria-selected", "true");
      elt.id = (this || _global).id + "-" + i;
      elt.setAttribute("role", "option");
      if (cur.render) cur.render(elt, data, cur);else elt.appendChild(ownerDocument.createTextNode(cur.displayText || getText(cur)));
      elt.hintId = i;
    }
    var container = completion.options.container || ownerDocument.body;
    var pos = cm.cursorCoords(completion.options.alignWithWord ? data.from : null);
    var left = pos.left,
      top = pos.bottom,
      below = true;
    var offsetLeft = 0,
      offsetTop = 0;
    if (container !== ownerDocument.body) {
      // We offset the cursor position because left and top are relative to the offsetParent's top left corner.
      var isContainerPositioned = ["absolute", "relative", "fixed"].indexOf(parentWindow.getComputedStyle(container).position) !== -1;
      var offsetParent = isContainerPositioned ? container : container.offsetParent;
      var offsetParentPosition = offsetParent.getBoundingClientRect();
      var bodyPosition = ownerDocument.body.getBoundingClientRect();
      offsetLeft = offsetParentPosition.left - bodyPosition.left - offsetParent.scrollLeft;
      offsetTop = offsetParentPosition.top - bodyPosition.top - offsetParent.scrollTop;
    }
    hints.style.left = left - offsetLeft + "px";
    hints.style.top = top - offsetTop + "px";

    // If we're at the edge of the screen, then we want the menu to appear on the left of the cursor.
    var winW = parentWindow.innerWidth || Math.max(ownerDocument.body.offsetWidth, ownerDocument.documentElement.offsetWidth);
    var winH = parentWindow.innerHeight || Math.max(ownerDocument.body.offsetHeight, ownerDocument.documentElement.offsetHeight);
    container.appendChild(hints);
    cm.getInputField().setAttribute("aria-autocomplete", "list");
    cm.getInputField().setAttribute("aria-owns", (this || _global).id);
    cm.getInputField().setAttribute("aria-activedescendant", (this || _global).id + "-" + (this || _global).selectedHint);
    var box = completion.options.moveOnOverlap ? hints.getBoundingClientRect() : new DOMRect();
    var scrolls = completion.options.paddingForScrollbar ? hints.scrollHeight > hints.clientHeight + 1 : false;

    // Compute in the timeout to avoid reflow on init
    var startScroll;
    setTimeout(function () {
      startScroll = cm.getScrollInfo();
    });
    var overlapY = box.bottom - winH;
    if (overlapY > 0) {
      // Does not fit below
      var height = box.bottom - box.top,
        spaceAbove = box.top - (pos.bottom - pos.top) - 2;
      if (winH - box.top < spaceAbove) {
        // More room at the top
        if (height > spaceAbove) hints.style.height = (height = spaceAbove) + "px";
        hints.style.top = (top = pos.top - height) + offsetTop + "px";
        below = false;
      } else {
        hints.style.height = winH - box.top - 2 + "px";
      }
    }
    var overlapX = box.right - winW;
    if (scrolls) overlapX += cm.display.nativeBarWidth;
    if (overlapX > 0) {
      if (box.right - box.left > winW) {
        hints.style.width = winW - 5 + "px";
        overlapX -= box.right - box.left - winW;
      }
      hints.style.left = (left = Math.max(pos.left - overlapX - offsetLeft, 0)) + "px";
    }
    if (scrolls) for (var node = hints.firstChild; node; node = node.nextSibling) node.style.paddingRight = cm.display.nativeBarWidth + "px";
    cm.addKeyMap((this || _global).keyMap = buildKeyMap(completion, {
      moveFocus: function (n, avoidWrap) {
        widget.changeActive(widget.selectedHint + n, avoidWrap);
      },
      setFocus: function (n) {
        widget.changeActive(n);
      },
      menuSize: function () {
        return widget.screenAmount();
      },
      length: completions.length,
      close: function () {
        completion.close();
      },
      pick: function () {
        widget.pick();
      },
      data: data
    }));
    if (completion.options.closeOnUnfocus) {
      var closingOnBlur;
      cm.on("blur", (this || _global).onBlur = function () {
        closingOnBlur = setTimeout(function () {
          completion.close();
        }, 100);
      });
      cm.on("focus", (this || _global).onFocus = function () {
        clearTimeout(closingOnBlur);
      });
    }
    cm.on("scroll", (this || _global).onScroll = function () {
      var curScroll = cm.getScrollInfo(),
        editor = cm.getWrapperElement().getBoundingClientRect();
      if (!startScroll) startScroll = cm.getScrollInfo();
      var newTop = top + startScroll.top - curScroll.top;
      var point = newTop - (parentWindow.pageYOffset || (ownerDocument.documentElement || ownerDocument.body).scrollTop);
      if (!below) point += hints.offsetHeight;
      if (point <= editor.top || point >= editor.bottom) return completion.close();
      hints.style.top = newTop + "px";
      hints.style.left = left + startScroll.left - curScroll.left + "px";
    });
    CodeMirror.on(hints, "dblclick", function (e) {
      var t = getHintElement(hints, e.target || e.srcElement);
      if (t && t.hintId != null) {
        widget.changeActive(t.hintId);
        widget.pick();
      }
    });
    CodeMirror.on(hints, "click", function (e) {
      var t = getHintElement(hints, e.target || e.srcElement);
      if (t && t.hintId != null) {
        widget.changeActive(t.hintId);
        if (completion.options.completeOnSingleClick) widget.pick();
      }
    });
    CodeMirror.on(hints, "mousedown", function () {
      setTimeout(function () {
        cm.focus();
      }, 20);
    });

    // The first hint doesn't need to be scrolled to on init
    var selectedHintRange = this.getSelectedHintRange();
    if (selectedHintRange.from !== 0 || selectedHintRange.to !== 0) {
      this.scrollToActive();
    }
    CodeMirror.signal(data, "select", completions[(this || _global).selectedHint], hints.childNodes[(this || _global).selectedHint]);
    return true;
  }
  Widget.prototype = {
    close: function () {
      if ((this || _global).completion.widget != (this || _global)) return;
      (this || _global).completion.widget = null;
      if ((this || _global).hints.parentNode) (this || _global).hints.parentNode.removeChild((this || _global).hints);
      (this || _global).completion.cm.removeKeyMap((this || _global).keyMap);
      var input = (this || _global).completion.cm.getInputField();
      input.removeAttribute("aria-activedescendant");
      input.removeAttribute("aria-owns");
      var cm = (this || _global).completion.cm;
      if ((this || _global).completion.options.closeOnUnfocus) {
        cm.off("blur", (this || _global).onBlur);
        cm.off("focus", (this || _global).onFocus);
      }
      cm.off("scroll", (this || _global).onScroll);
    },
    disable: function () {
      (this || _global).completion.cm.removeKeyMap((this || _global).keyMap);
      var widget = this || _global;
      (this || _global).keyMap = {
        Enter: function () {
          widget.picked = true;
        }
      };
      (this || _global).completion.cm.addKeyMap((this || _global).keyMap);
    },
    pick: function () {
      (this || _global).completion.pick((this || _global).data, (this || _global).selectedHint);
    },
    changeActive: function (i, avoidWrap) {
      if (i >= (this || _global).data.list.length) i = avoidWrap ? (this || _global).data.list.length - 1 : 0;else if (i < 0) i = avoidWrap ? 0 : (this || _global).data.list.length - 1;
      if ((this || _global).selectedHint == i) return;
      var node = (this || _global).hints.childNodes[(this || _global).selectedHint];
      if (node) {
        node.className = node.className.replace(" " + ACTIVE_HINT_ELEMENT_CLASS, "");
        node.removeAttribute("aria-selected");
      }
      node = (this || _global).hints.childNodes[(this || _global).selectedHint = i];
      node.className += " " + ACTIVE_HINT_ELEMENT_CLASS;
      node.setAttribute("aria-selected", "true");
      (this || _global).completion.cm.getInputField().setAttribute("aria-activedescendant", node.id);
      this.scrollToActive();
      CodeMirror.signal((this || _global).data, "select", (this || _global).data.list[(this || _global).selectedHint], node);
    },
    scrollToActive: function () {
      var selectedHintRange = this.getSelectedHintRange();
      var node1 = (this || _global).hints.childNodes[selectedHintRange.from];
      var node2 = (this || _global).hints.childNodes[selectedHintRange.to];
      var firstNode = (this || _global).hints.firstChild;
      if (node1.offsetTop < (this || _global).hints.scrollTop) (this || _global).hints.scrollTop = node1.offsetTop - firstNode.offsetTop;else if (node2.offsetTop + node2.offsetHeight > (this || _global).hints.scrollTop + (this || _global).hints.clientHeight) (this || _global).hints.scrollTop = node2.offsetTop + node2.offsetHeight - (this || _global).hints.clientHeight + firstNode.offsetTop;
    },
    screenAmount: function () {
      return Math.floor((this || _global).hints.clientHeight / (this || _global).hints.firstChild.offsetHeight) || 1;
    },
    getSelectedHintRange: function () {
      var margin = (this || _global).completion.options.scrollMargin || 0;
      return {
        from: Math.max(0, (this || _global).selectedHint - margin),
        to: Math.min((this || _global).data.list.length - 1, (this || _global).selectedHint + margin)
      };
    }
  };
  function applicableHelpers(cm, helpers) {
    if (!cm.somethingSelected()) return helpers;
    var result = [];
    for (var i = 0; i < helpers.length; i++) if (helpers[i].supportsSelection) result.push(helpers[i]);
    return result;
  }
  function fetchHints(hint, cm, options, callback) {
    if (hint.async) {
      hint(cm, callback, options);
    } else {
      var result = hint(cm, options);
      if (result && result.then) result.then(callback);else callback(result);
    }
  }
  function resolveAutoHints(cm, pos) {
    var helpers = cm.getHelpers(pos, "hint"),
      words;
    if (helpers.length) {
      var resolved = function (cm, callback, options) {
        var app = applicableHelpers(cm, helpers);
        function run(i) {
          if (i == app.length) return callback(null);
          fetchHints(app[i], cm, options, function (result) {
            if (result && result.list.length > 0) callback(result);else run(i + 1);
          });
        }
        run(0);
      };
      resolved.async = true;
      resolved.supportsSelection = true;
      return resolved;
    } else if (words = cm.getHelper(cm.getCursor(), "hintWords")) {
      return function (cm) {
        return CodeMirror.hint.fromList(cm, {
          words: words
        });
      };
    } else if (CodeMirror.hint.anyword) {
      return function (cm, options) {
        return CodeMirror.hint.anyword(cm, options);
      };
    } else {
      return function () {};
    }
  }
  CodeMirror.registerHelper("hint", "auto", {
    resolve: resolveAutoHints
  });
  CodeMirror.registerHelper("hint", "fromList", function (cm, options) {
    var cur = cm.getCursor(),
      token = cm.getTokenAt(cur);
    var term,
      from = CodeMirror.Pos(cur.line, token.start),
      to = cur;
    if (token.start < cur.ch && /\w/.test(token.string.charAt(cur.ch - token.start - 1))) {
      term = token.string.substr(0, cur.ch - token.start);
    } else {
      term = "";
      from = cur;
    }
    var found = [];
    for (var i = 0; i < options.words.length; i++) {
      var word = options.words[i];
      if (word.slice(0, term.length) == term) found.push(word);
    }
    if (found.length) return {
      list: found,
      from: from,
      to: to
    };
  });
  CodeMirror.commands.autocomplete = CodeMirror.showHint;
  var defaultOptions = {
    hint: CodeMirror.hint.auto,
    completeSingle: true,
    alignWithWord: true,
    closeCharacters: /[\s()\[\]{};:>,]/,
    closeOnPick: true,
    closeOnUnfocus: true,
    updateOnCursorActivity: true,
    completeOnSingleClick: true,
    container: null,
    customKeys: null,
    extraKeys: null,
    paddingForScrollbar: true,
    moveOnOverlap: true
  };
  CodeMirror.defineOption("hintOptions", null);
});
export default {};